import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose, bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { Navigation } from "./navigation";
import { VideoListingComponent } from "./videosListing";
import { LoaderComponent } from "../../components/loader";
import HelmetComponent from "../../components/shared/Helmet";
import cosmeticConfig from '../../../config/cosmeticConfig';

// actions
import {
  getForYouSubMenuDataAction,
  resetForYouResults,
  setSignupModalStatus
} from "../../actions";

import { isEmpty } from "@aws-amplify/core";

class ForyouPage extends PureComponent {
  state = {
    offset: cosmeticConfig.foryou.OFFSET,
    max: cosmeticConfig.foryou.MAX,
    lastScrollTop: 0
  };

  componentDidMount() {
    // get sub Menu List
    const { match: { url } = {}, location: { search } = {} } = this.props;
    this.getSubMenuListData();
    this.lazyLoadContainer = React.createRef();
    window.addEventListener("scroll", this.onScroll, false); // bind scroll event
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll, false);
  }

  componentDidUpdate(prevProps) {
    const {
      match: { url: newUrl },
      location: { search } = {}
    } = this.props;
    const {
      match: { url: oldUrl }
    } = prevProps;
    if (oldUrl !== newUrl) {
      this.setState(
        {
          offset: 0
        },
        () => {
          this.props.resetForYouResults();
          this.getSubMenuListData();
        }
      );
    }
  }

  getSubMenuListData = async () => {
    const { max, offset } = this.state;
    const { getForYouSubMenuDataAction, currentLanguage } = this.props;
    let token = localStorage.getItem("token")
    await getForYouSubMenuDataAction({ offset, max, token, language: currentLanguage });
  };



  ///  lazy load on scroll
  onScroll = () => {
    const {
      match: { url } = {},
      location: { search } = {},
      tierReducer: { isSubMenuDataLoading, subMenuData }
    } = this.props;
    const {
      lastScrollTop
    } = this.state
    const {
      top: containerTop
    } = this.lazyLoadContainer.current.getBoundingClientRect();
    var st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > lastScrollTop) {
      this.setState({
        lastScrollTop: st <= 0 ? 0 : st
      })
      // downscroll code
    } else {
      this.setState({
        lastScrollTop: st <= 0 ? 0 : st
      })
      return;
      // upscroll code
    }
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 200) {
      const listing =
        subMenuData &&
        Object.values(subMenuData).map(values => values);
      const lastList =
        Array.isArray(listing) && listing.length && listing[listing.length - 1];
      const totalCount =
        subMenuData &&
        Object.values(subMenuData).map(values => values.totalCount);
      if (!isSubMenuDataLoading && containerTop < 100 && lastList.length && this.state.offset <= totalCount) {
        this.setState(
          prevState => ({
            offset: prevState.offset + prevState.max
          }),
          () => {
            this.getSubMenuListData();
          }
        );
      }
    }
  };

  openSigninModalPopup = (formName) => {
    this.props.setSignupModalStatus(true, formName);
  };

  render() {
    const { tierReducer } = this.props;
    const {
      subMenuData = {},
      isSubMenuDataLoading
    } = tierReducer;


    //Total items count and items from list
    let totalResults = -1;
    const listing =
      subMenuData &&
      Object.values(subMenuData).map(values => {
        if (!isEmpty(values)) {
          totalResults = totalResults > 0 ? totalResults + values.length : values.length;
        } else {
          totalResults = totalResults > 0 ? totalResults : 0;
        }
        return values;
      });




    return (
      <React.Fragment>
        <HelmetComponent
          title={" For you personalized stories | ausbiz"}
          noIndex="true"
        />
        <div className="contentWhite foryou-wrapper">
          <LoaderComponent isLoading={isSubMenuDataLoading} />
          {!this.props.token && !isSubMenuDataLoading && // non logged in state
            <div className="foryou-signup">
              <div className="foryou-signup-info">
                <h2>Add to your Watchlist</h2>
                <p>Your personalised feed of content based on <br />companies, experts and topics in your Watchlist.</p>
                <div className="foryou-btns" onClick={() => this.openSigninModalPopup("signup")}>
                  <span>Sign up for free</span>
                </div>
                <div className="foryou-account-line" onClick={() => this.openSigninModalPopup("signin")}>
                  <span>Already have an account? <em>Sign in</em></span>
                </div>
              </div>
              <div className="fooryou-signup-img">
                <img src="../../assets/foryou-signed.png" />
              </div>
            </div>
          }
          {this.props.token && totalResults == 0 && // logged in state with no stories
            <div className="foryou-signup foryou-signin">
              <div className="foryou-signup-info">
                <h2>Add to your Watchlist</h2>
                <p>Your personalised feed of content based on <br />companies, experts and topics in your Watchlist.</p>
                <Link to="/follow-management">
                  <div className="foryou-btns">
                    <span>Go to my Watchlist</span>
                  </div>
                </Link>
              </div>
              <div className="fooryou-signup-img">
                <img src="../../assets/foryou-signed.png" />
              </div>
            </div>
          }
          {this.props.token && totalResults > 0 && // logged in with strories
            <section className="tier-container">
              <section className="tier-navigation">
                <Navigation
                  isLoggedIn={this.props.token ? true : false}
                />
              </section>
              <section
                className="container tier-listing"
                ref={this.lazyLoadContainer}
              >
                <div className="row">
                  <VideoListingComponent
                    listing={listing}
                    totalResults={totalResults}
                    isLoading={!isSubMenuDataLoading}
                  />
                </div>
              </section>
            </section>
          }
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    tierReducer: state.forYouPage,
    token: state.auth.token,
    currentLanguage: state.language.currentLanguage
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getForYouSubMenuDataAction,
      resetForYouResults,
      setSignupModalStatus: (status, requestedForm) => dispatch(setSignupModalStatus(status, requestedForm))
    },
    dispatch
  );
}

function loadData(store) {
  return store.dispatch(getForYouSubMenuDataAction());
}

export default {
  component: compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
  )(ForyouPage)
};
